import React, { useEffect, useState } from 'react';
import SiparisDetayModal from '../SiparisDetayModal';
import { fetchSiparisDetay } from '../../services/siparisService';

/**
 * Sipariş detayını API'den yükleyip mevcut SiparisDetayModal ile gösterir (stok akışı içi, nested).
 */
const StokSiparisDetayFetchModal = ({ siparisId, onClose }) => {
  const [siparis, setSiparis] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!siparisId) return;
    let cancelled = false;
    setLoading(true);
    setError('');
    setSiparis(null);
    fetchSiparisDetay(siparisId)
      .then((res) => {
        if (cancelled) return;
        if (res?.basarili && res?.veri) {
          setSiparis(res.veri);
        } else {
          setError(res?.mesaj || 'Sipariş yüklenemedi');
        }
      })
      .catch((e) => {
        if (!cancelled) setError(e?.data?.mesaj || e?.message || 'Sipariş yüklenemedi');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [siparisId]);

  if (!siparisId) return null;

  if (loading) {
    return (
      <div className="modal-overlay siparis-detay-modal siparis-detay-modal--nested stok-siparis-fetch-modal" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px', padding: '24px' }}>
          <p style={{ margin: 0, textAlign: 'center' }}>Sipariş yükleniyor…</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modal-overlay siparis-detay-modal siparis-detay-modal--nested stok-siparis-fetch-modal" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px', padding: '24px' }}>
          <div className="alert alert-danger" style={{ marginBottom: '12px' }}>{error}</div>
          <button type="button" className="secondary-btn" onClick={onClose}>
            Kapat
          </button>
        </div>
      </div>
    );
  }

  return <SiparisDetayModal siparis={siparis} onClose={onClose} nested />;
};

export default StokSiparisDetayFetchModal;
